import React, { Component } from "react";
import styles from "./donationCard.module.scss";
import {
  BLOOD_CLASES,
  DONATION_STATUSES,
  DONATION_TYPES,
} from "../../../../entities";
import moment from "moment";
import redirectTo from "../../../../utils/redirectTo";
import { Modal, Popup } from "semantic-ui-react";
import Link from "next/link";
import { sendMetrics } from "../../../../utils/misc";
import { inject, observer } from "mobx-react";

const dots = "/static/images/icons/dots.svg";
const withoutImage = "/static/images/withoutImage.svg";

@inject("donationStore")
@inject("uiStore")
@observer
class DonationsCard extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      openDesktopModal: false,
      openedToolTip: false,
      isDonationRemoved: false,
    };
  }

  deleteDonation = () => {
    this.props.donationStore
      .deleteDonation(this.props.donation.id)
      .then(() => {
        sendMetrics("remove_donation");
        this.setState({
          isDonationRemoved: true,
        });
        setTimeout(() => {
          if (window) {
            window.location.reload();
          }
        }, 2000);
      })
      .catch((response) => console.error(response));
  };

  toggleDesktopModal = (withMetric) => {
    this.setState({
      openDesktopModal: !this.state.openDesktopModal,
    });
    if (withMetric) {
      sendMetrics(withMetric);
    }
  };

  toggleToolTip = () => {
    this.setState({
      openedToolTip: !this.state.openedToolTip,
    });
  };

  render() {
    const {
      donation,
      isFull = false,
      isLinkActive = true,
      enableNotViewed = false,
    } = this.props;
    const normal_link = donation.image?.small
      ? donation.image.small
      : donation.image
      ? donation.image
      : donation.legacy_image;
    const no_image = normal_link ? normal_link : withoutImage;
    const image_link = donation.with_image ? no_image : withoutImage;
    const linkTo = () => {
      if (donation.id && isLinkActive) {
        redirectTo(`/profile/donations/${donation.id}/`);
      }
    };
    return (
      <>
        <div className={styles.donationCard} onClick={linkTo}>
          {enableNotViewed && donation.has_reply && !donation.reply_viewed && (
            <div className={styles.donationCard_Notify}>
              <div>
                <span>!</span>
              </div>
            </div>
          )}
          <div className={styles.donationCardMainHeader}>
            <span>{moment(donation.donate_at).format("D MMMM Y")}</span>
            {!this.props.uiStore.isMobile && !this.state.openDesktopModal && (
              <Popup
                className={styles.Popups}
                inverted
                basic
                style={{ backgroundColor: "#333333" }}
                position={"left center"}
                mouseLeaveDelay={1000}
                hoverable
                hideOnScroll={true}
                trigger={
                  <img src={dots} alt="" onClick={(e) => e.stopPropagation()} />
                }
              >
                <div className={styles.Popup}>
                  <Link href={`/profile/donations/${donation.id}/edit/`}>
                    <span
                      className={styles.PopupEdit}
                      onClick={(e) => {
                        e.stopPropagation();
                        sendMetrics("to_edit_donation_from_card");
                      }}
                    >
                      <img src="/static/images/icons/pencil.svg" alt="" />
                      Редактировать
                    </span>
                  </Link>
                  {
                    donation.allowed_modify &&
                    <span
                      className={styles.PopupRemove}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.toggleDesktopModal("delete_donation_from_card");
                      }}
                    >
                      <img src="/static/images/icons/redBucket.svg" alt="" />
                      Удалить
                    </span>
                  }
                </div>
              </Popup>
            )}
            {this.props.uiStore.isMobile && (
              <img
                src={dots}
                alt=""
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggleToolTip();
                }}
              />
            )}
          </div>
          <div
            className={
              isFull
                ? styles.donationCardMainNameFull
                : styles.donationCardMainName
            }
          >
            {!donation.is_out && (
              <span title={donation.blood_station?.title}>
                {donation.blood_station?.title}
              </span>
            )}
            {donation.is_out && <span>Выездная акция</span>}
          </div>
          <div className={styles.donationCardMainAddress}>
            {donation.blood_station && (
              <span>{donation.blood_station?.address}</span>
            )}
          </div>
          <div className={styles.donationCardMainType}>
            <img
              src={
                (donation.status === "accepted" || donation.status === "pre_accepted")
                  ? BLOOD_CLASES[donation.blood_class]?.icon
                  : BLOOD_CLASES[donation.blood_class]?.not_approved_icon
              }
              alt=""
            />
            <span>{BLOOD_CLASES[donation.blood_class]?.title}</span>
          </div>
          <div className={styles.donationCardMainStatus}>
            <div className={styles.donationCardMainStatusType}>
              <span>
                {donation.payment_type
                  ? DONATION_TYPES[donation.payment_type].main
                  : ""}
              </span>
              {donation.with_image && (
                <span>
                  <img src={DONATION_STATUSES[donation.status].icon} alt="" />
                  {DONATION_STATUSES[donation.status].title}
                </span>
              )}
              {!donation.with_image && (
                <span>
                  <img src={DONATION_STATUSES["without_image"].icon} alt="" />
                  {DONATION_STATUSES["without_image"].title}
                </span>
              )}
            </div>
            {donation.with_image && (
              <div className={styles.donationCardMainStatusImage}>
                <div style={{ backgroundImage: `url(${image_link})` }} />
              </div>
            )}
            {!donation.with_image && (
              <div className={styles.donationCardMainStatusNoImage}>
                <img src={image_link} alt="" />
                <span>Отсутствует справка</span>
              </div>
            )}
          </div>
        </div>
        <DeleteModal
          openDesktopModal={this.state.openDesktopModal}
          deleteDonation={this.deleteDonation}
          isMobile={this.props.uiStore.isMobile}
          isDonationRemoved={this.state.isDonationRemoved}
          toggleDesktopModal={this.toggleDesktopModal}
        />
        <ToolTip
          openedToolTip={this.state.openedToolTip}
          donation={donation}
          isMobile={this.props.uiStore.isMobile}
          toggleDesktopModal={this.toggleDesktopModal}
          toggleToolTip={this.toggleToolTip}
        />
      </>
    );
  }
}

export default DonationsCard;

const DeleteModal = ({
  openDesktopModal,
  toggleDesktopModal,
  deleteDonation,
  isMobile,
  isDonationRemoved,
}) => {
  return (
    <Modal
      style={
        !isMobile
          ? {
              top: "auto",
              left: "auto",
              margin: "auto",
              maxWidth: "480px",
              height: "auto",
            }
          : {
              paddingBottom: "0",
              bottom: "-2px",
              width: "100%",
              marginBottom: "0em",
              top: "unset",
              height: "auto",
            }
      }
      open={openDesktopModal}
      onClose={toggleDesktopModal}
    >
      <Modal.Content
        style={{
          padding: "35px 48px",
        }}
      >
        <div className={styles.InsideModal}>
          <img
            src={
              isDonationRemoved
                ? "/static/images/icons/circle-checked.svg"
                : "/static/images/icons/removeModal.svg"
            }
            alt=""
          />
          <div className={styles.InsideModal_Center}>
            <h1>
              {isDonationRemoved ? "Донация удалена" : "Удалить донацию?"}
            </h1>
            <span>
              Восстановить донацию можно только через службу поддержки -
              <br />
              <a href={"mailto:support@donorsearch.org"}>
                {" "}
                support@donorsearch.org
              </a>
              .
            </span>
          </div>
          {!isDonationRemoved && (
            <div className={styles.InsideModal_Bottom}>
              <button
                className={styles.InsideModal_Bottom_Decline}
                onClick={toggleDesktopModal}
              >
                Отмена
              </button>
              <button
                className={styles.InsideModal_Bottom_Accept}
                onClick={deleteDonation}
              >
                Удалить донацию
              </button>
            </div>
          )}
        </div>
      </Modal.Content>
    </Modal>
  );
};

const ToolTip = ({
  openedToolTip,
  toggleToolTip,
  donation,
  toggleDesktopModal,
  isMobile,
}) => {
  const openMod = () => {
    toggleToolTip();
    toggleDesktopModal();
  };
  return (
    <Modal
      style={
        !isMobile
          ? {
              top: "auto",
              left: "auto",
              margin: "auto",
              maxWidth: "480px",
              height: "auto",
              display: "none",
            }
          : {
              paddingBottom: "0",
              bottom: "-2px",
              width: "100%",
              marginBottom: "0em",
              top: "unset",
              height: "auto",
            }
      }
      open={openedToolTip}
      onClose={toggleToolTip}
    >
      <Modal.Content
        style={{
          padding: "35px 48px",
        }}
      >
        <div className={styles.InsideModalToolTip}>
          <div className={styles.InsideModalToolTipHeader}>
            <span>Действия</span>
            <img
              src="/static/images/icons/close.svg"
              alt=""
              onClick={toggleToolTip}
            />
          </div>
          <div className={styles.InsideModalToolTipBody}>
            <Link href={`/profile/donations/${donation.id}/edit/`}>
              <div className={styles.InsideModalToolTipBodyEdit}>
                <div className={styles.InsideModalToolTipBodyImage}>
                  <img src="/static/images/icons/cardPencil.svg" alt="" />
                </div>
                <span>Редактировать</span>
              </div>
            </Link>
            {
              donation.allowed_modify &&
              <div
                className={styles.InsideModalToolTipBodyDelete}
                onClick={openMod}
              >
                <div className={styles.InsideModalToolTipBodyImage}>
                  <img src="/static/images/icons/redBucket.svg" alt="" />
                </div>
                <span>Удалить</span>
              </div>
            }
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
